import React from "react";

const Support = () => {
  return (
    <div className="tw-flex tw-gap-8 tw-flex-start tw-justify-start tw-flex-col-reverse lg:tw-flex-row">
      <div className="tw-w-full tw-bg-white dark:tw-bg-black tw-px-6 sm:tw-px-10 tw-py-8 tw-rounded-2xl tw-shadow-sm tw-h-full">
        <h2 className="tw-text-2xl tw-font-semibold tw-mb-2 dark:tw-text-white">
          We’d love your feedback
        </h2>
        <p className="tw-text-gray-600 dark:tw-text-gray-300 tw-mb-6">
          Let us know how the trackers are working for you — if you’ve run into
          any bugs or have feedback, we’d love to hear it.
        </p>
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            const formData = new FormData(e.target);
            const email = formData.get("email");
            const message = formData.get("message");

            const response = await fetch("/api/send-feedback", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ email, message }),
            });

            if (response.ok) {
              alert("Thank you for your feedback!");
              e.target.reset();
            } else {
              alert("Something went wrong. Please try again.");
            }
          }}
          className="tw-flex tw-flex-col tw-gap-4 tw-flex-start tw-items-start"
        >
          <label className="tw-font-medium tw-w-full">
            Your email
            <input
              type="email"
              name="email"
              required
              className="tw-w-full tw-mt-1 tw-px-3 tw-py-2 tw-border tw-rounded tw-bg-white dark:tw-bg-black tw-text-black dark:tw-text-white"
            />
          </label>
          <label className="tw-font-medium tw-w-full">
            Message
            <textarea
              name="message"
              required
              rows="5"
              className="tw-w-full tw-mt-1 tw-px-3 tw-py-2 tw-border tw-rounded tw-bg-white dark:tw-bg-black tw-text-black dark:tw-text-white"
            />
          </label>
          <button
            type="submit"
            className="tw-bg-black dark:tw-bg-white tw-px-7 tw-text-white dark:tw-text-black tw-py-3 tw-rounded-full hover:tw-opacity-80"
          >
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
};

export default Support;
